let meta = {
  app_title: 'Solaris Works',
  pages: {
    home: {
      title: 'Home',
      path: '',
      icon: 'mdi-view-dashboard'
    },
    scheduler: {
      title: 'Agenda',
      path: 'agenda',
      icon: 'mdi-calendar-clock',
      type: 'page',
      pages: {
        launches: {
          title: 'Lançamentos',
          path: 'lancamentos',
          icon: 'mdi-update'
        },
        calendar: {
          title: 'Calendário',
          path: 'calendario',
          icon: 'mdi-calendar-multiselect'
        },
        list: {
          title: 'Lista',
          path: 'lista',
          icon: 'mdi-view-list'
        }
      }
    },
    orders: {
      title: 'Vendas',
      path: 'vendas',
      icon: 'mdi-view-list'
    },
    catalog: {
      title: 'Catálogo',
      path: 'catalogo',
      icon: 'mdi-format-list-text',
      type: 'page',
      pages: {
        services: {
          title: 'Serviços',
          path: 'servicos',
          icon: 'mdi-face-woman'
        },
        items: {
          title: 'Produtos',
          path: 'produtos',
          icon: 'mdi-package-variant'
        }
      }
    },
    menu: {
      title: 'Cardápio',
      path: 'cardapio',
      icon: 'mdi-format-list-text'
    },
    customers: {
      title: 'Clientes',
      path: 'clientes',
      icon: 'mdi-account-group'
    },
    financial: {
      title: 'Financeiro',
      path: 'financeiro',
      icon: 'mdi-finance',
      type: 'page',
      pages: {
        summary: {
          title: 'Resumo',
          path: 'resumo',
          icon: 'mdi-view-dashboard'
        },
        cash_flow: {
          title: 'Fluxo de Caixa',
          path: 'fluxo',
          icon: 'mdi-cash-register'
        },
        bills: {
          title: 'Contas',
          path: 'contas',
          icon: 'mdi-file-document-multiple'
        },
        salary: {
          title: 'Remunerações',
          path: 'salarios',
          icon: 'mdi-account-tie'
        },
        reports: {
          title: 'Relatórios',
          path: 'relatorios',
          icon: 'mdi-chart-areaspline'
        }
      }
    },
    historic: {
      title: 'Histórico',
      path: 'historico',
      icon: 'mdi-history',
      type: 'root',
      pages: {
        orders: {
          title: 'Vendas',
          path: 'vendas',
          icon: 'mdi-view-list'
        },
        catalog: {
          title: 'Catálogo',
          path: 'catalogo',
          icon: 'mdi-format-list-text'
        },
        customers: {
          title: 'Clientes',
          path: 'clientes',
          icon: 'mdi-account-group'
        },
        graphs: {
          title: 'Gráficos',
          path: 'graficos',
          icon: 'mdi-chart-line'
        }
      }
    },
    users: {
      title: 'Profissionais',
      path: 'profissionais',
      icon: 'mdi-account-tie'
    },
    config: {
      title: 'Configurações',
      path: 'config',
      icon: 'mdi-cogs',
      type: 'page',
      pages: {
        app: {
          title: 'App',
          path: 'app',
          icon: 'mdi-application'
        },
        themes: {
          title: 'Temas',
          path: 'temas',
          icon: 'mdi-apps'
        },
        permissions: {
          title: 'Permissões',
          path: 'permissoes',
          icon: 'mdi-account-network'
        },
        defaults: {
          title: 'Predefinições',
          path: 'predefinicoes',
          icon: 'mdi-earth'
        }
      }
    },
    admin: {
      title: 'Desenvolvedor',
      path: 'admin',
      icon: 'mdi-server-network'
    },
    test: {
      title: 'Página Teste',
      path: 'teste',
      icon: 'mdi-alien'
    },
    default: {
      title: 'Principal',
      path: null,
      icon: ''
    },
    actions: {
      new: 'novo',
      edit: 'editar',
      repeat: 'repetir'
    }
  }
}

export default meta
